import { motion } from "framer-motion";
import { Check } from "lucide-react";

const POINTS = [
  "Print-on-demand — every item made to order",
  "Fulfilled worldwide through Printful",
  "Heavyweight 240 GSM organic cotton",
  "Original tiger artwork on every drop",
];

export const AboutSection = () => {
  return (
    <section id="about" data-testid="about-section" className="bg-fog py-16 sm:py-24 lg:py-32">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-4 sm:px-8 lg:grid-cols-2 lg:px-12">
        <motion.div
          initial={{ opacity: 0, x: -32 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="relative"
        >
          <div className="absolute -right-4 -top-4 h-full w-full border-2 border-zinc-300" />
          <img
            src="/assets/mockup-3.jpg"
            alt="Tiger Clothing brand studio"
            className="relative h-[380px] w-full object-cover sm:h-[460px]"
            data-testid="about-image"
          />
          <img
            src="/assets/logo-orange.png"
            alt="Tiger Clothing logo"
            className="absolute -bottom-8 -right-8 w-28 border-4 border-white bg-white sm:w-36"
            data-testid="about-logo"
          />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 32 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
        >
          <p className="mb-3 flex items-center gap-3 font-body text-xs font-medium uppercase tracking-[0.3em] text-tiger">
            <span className="h-px w-8 bg-tiger" />Our Story
          </p>
          <h2 className="font-heading text-2xl font-bold uppercase tracking-tight text-zinc-900 sm:text-3xl lg:text-4xl">
            Born Fierce. <span className="text-tiger">Made To Order.</span>
          </h2>
          <p className="mt-6 font-body text-sm leading-relaxed text-zinc-600 sm:text-base">
            Tiger Clothing is a UK streetwear label built around one idea: fierce attire for people
            who move with purpose. Every design is printed on demand through Printful, so nothing is
            mass-produced and nothing goes to waste — your piece is made the moment you order it.
          </p>
          <ul className="mt-8 space-y-3">
            {POINTS.map((point) => (
              <li key={point} className="flex items-center gap-3 font-body text-sm text-zinc-700">
                <span className="flex h-6 w-6 items-center justify-center bg-tiger text-black">
                  <Check size={14} strokeWidth={3} />
                </span>
                {point}
              </li>
            ))}
          </ul>
          <a
            href="#shop"
            data-testid="about-shop-btn"
            className="mt-10 inline-block bg-zinc-900 px-8 py-4 font-heading text-sm font-bold uppercase tracking-widest text-white transition-colors hover:bg-tiger hover:text-black"
          >
            Shop The Drop
          </a>
        </motion.div>
      </div>
    </section>
  );
};
